const initialState = {
    sessions: [],
    status: "idle",
    lastCreatedSession:null
  };

export default initialState;